import { useOutletContext } from "react-router";

import GaiaPagination from "~/modules/app/components/GaiaPagination";

import { ProjectReviewVisitV2FunctionListRouteOutletContext } from "..";
import { ProjectReviewVisitV2FunctionList } from "../components/ProjectReviewVisitV2FunctionList";

export function CreatedFunctionsTab() {
    const { ecologicalFunctions, page, pageSize, onPageChange } =
        useOutletContext<ProjectReviewVisitV2FunctionListRouteOutletContext>();

    const createLinkToEcologicalFunction = (fn: NonNullable<(typeof ecologicalFunctions)["data"]>[number]) => {
        return `./${fn.featureId}`;
    };

    return (
        <>
            <ProjectReviewVisitV2FunctionList
                createTo={createLinkToEcologicalFunction}
                ecologicalFunctions={ecologicalFunctions.data ?? []}
            />
            {(ecologicalFunctions.data?.length ?? 0) > 0 && ecologicalFunctions.queryInfo && (
                <GaiaPagination
                    sx={{ display: "flex", justifyContent: "center", paddingBlock: 2 }}
                    page={page}
                    onPageChange={onPageChange}
                    total={ecologicalFunctions.queryInfo.paginationOption.total ?? 0}
                    pageSize={pageSize}
                />
            )}
        </>
    );
}
